import {
  ROUTE_COMPANY_SUBSIDIARIES,
  ROUTE_COMPANY_SUBSIDIARIES_CHILD,
} from './routeNames'

const CompanySubsidiaries = () =>
  import('@/components/company_subsidiaries/CompanySubsidiariesPage.vue')

const CompanySubsidiariesChild = () =>
  import('@/components/company_subsidiaries/CompanySubsidiariesChildPage.vue')

const companySubsidiariesRoutes = [
  {
    name: ROUTE_COMPANY_SUBSIDIARIES,
    path: '/company-subsidiaries',
    component: CompanySubsidiaries,
    meta: { resource: 'Company' },
  },
  {
    name: ROUTE_COMPANY_SUBSIDIARIES_CHILD,
    path: '/company-subsidiaries/:organizationId',
    props: true,
    component: CompanySubsidiariesChild,
    meta: { resource: 'Company' },
  },
]

export default companySubsidiariesRoutes
